import type { Cents } from "./money";
import { ratioBasisPoints } from "./money";

const UNITS_PER_PERCENT = 100;

/** Nonnegative cents become basis-point widths; the complement cannot overfill. */
export function salarySplit(saved: Cents, ceiling: Cents): { savedPercent: number; spendPercent: number } {
  if (saved <= 0 && ceiling <= 0) return { savedPercent: 0, spendPercent: 0 };
  const savedUnits = ratioBasisPoints(saved, ceiling);
  const savedPercent = savedUnits / UNITS_PER_PERCENT;
  return { savedPercent, spendPercent: 100 - savedPercent };
}
